import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../../../shared/services/common.service';

@Component({
  selector: 'app-credentialdetails',
  templateUrl: './credentialdetails.component.html',
  styleUrl: './credentialdetails.component.css'
})
export class CredentialdetailsComponent {
  formData: any;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute, private toastrService: ToastrService, private commonService: CommonService, 
    ) {  }

  form = new FormGroup({
    msMeUserName: new FormControl('', [Validators.required, Validators.pattern(this.commonService.udyamNumber)]),
    password: new FormControl('', [Validators.required, Validators.pattern(this.commonService.passwordPattern)]),
    confpassword: new FormControl('', [Validators.required])
  }
    , {
      validators: this.passwordMatchValidator // Use it here as a form-level validator
    }
  );

  ngOnInit(): void {   
    if (sessionStorage.getItem('udyamRegistrationNumber')) {
      const username = sessionStorage.getItem('udyamRegistrationNumber');
      this.form.get('msMeUserName')?.setValue(username);
    }
    this.route.paramMap.subscribe(params => {
      this.formData = history.state.formData;
      if (this.formData && this.formData.ownersMobileNumber) {
        this.form.get('msMeUserName')?.setValue(this.formData.udyamRegistrationNumber);
        this.form.get('msMeUserName')?.disable();
      }
    });
  }
  get f() {
    return this.form.controls;
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  
  onReset() {
    this.form.reset();
    sessionStorage.clear();
    this.router.navigateByUrl('/login');
  }
  goto(form: any) {
    if (form.controls.password.value != form.controls.confpassword.value) {
      this.toastrService.error("Password and Confirm Password does not match")
      return;
    }
    if (form.valid) {
      const formdatavalue = {
        ...this.formData,
        ...this.getFormValuesIncludingDisabled(),
      };
      sessionStorage.setItem('credentialDetailsCompleted', 'true');
      this.toastrService.success('Your information is saved successfully.')
      this.router.navigate(['/personaldetails'], { state: { formData: formdatavalue } });
    } else {
      this.form.markAllAsTouched();
      return;
    }
  }

  getFormValuesIncludingDisabled() {
    const formValues = this.form.getRawValue();
    return {
      msMeUserName: formValues.msMeUserName,
      password: formValues.password
    };
  }
  onPaste(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
    alert('Pasting is disabled in the Confirm Password field for security reasons.');
  }
  passwordMatchValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confpassword')?.value;
    const confPasswordControl = group.get('confpassword'); // Get the confpassword control

    if (password && confirmPassword && password !== confirmPassword) {
      confPasswordControl?.setErrors({ ...confPasswordControl.errors, passwordMismatch: true }); // Set error
      return { passwordMismatch: true };
    }

    // Remove the passwordMismatch error if passwords match
    if (confPasswordControl?.errors) {
      const { passwordMismatch, ...otherErrors } = confPasswordControl.errors;
      if (Object.keys(otherErrors).length > 0) {
        confPasswordControl.setErrors(otherErrors); // Retain other errors
      } else {
        confPasswordControl.setErrors(null); // No errors left
      }
    }

    return null; // No error
  }
}
